import { formatPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

export default function formatInternationalPhoneNumber(value: string): string {
  const parsed = parsePhoneNumber(value);
  // 한국일때는 국가 코드를 보여주지 않습니다.
  if (parsed?.countryCallingCode === '82') {
    return formatPhoneNumber(value);
  }
  return `+${parsePhoneNumber(value)?.countryCallingCode} ${formatPhoneNumber(value)}`;
}
